import {Box} from '@mui/material';

const YouTubeEmbed = ({videoId}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        paddingTop: '56.25%',  // 16:9 aspect ratio
        borderRadius: 2,
        overflow: 'hidden',
        mt: 2
      }}
    >
      <Box
        component='iframe'
        src={`https://www.youtube.com/embed/${videoId}`}
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          border: 0
        }}
      />
    </Box>
  );
};

export default YouTubeEmbed;